import React from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect
} from "react-router-dom";

import App from "./App";
import Selected from "./Selected";


export default function Main() {

    return (
        <Router>
            <Switch>
                <Route exact path="/">
                    <App />
                </Route>
                <Route path="/selected/:id" component={Selected} />
                <Redirect to="/selected/:id"/>
            </Switch>

        </Router>
    )
}